import { render } from "./MdAvatar.vue?vue&type=template&id=609ec324"
import script from "./MdAvatar.vue?vue&type=script&lang=js"
export * from "./MdAvatar.vue?vue&type=script&lang=js"

import "./MdAvatar.vue?vue&type=style&index=0&id=609ec324&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__